import { defaultOptionsFetch, FetchAPI, FetchOptions, IAuthData, ICountry } from 'ufinet-web-functions'

export const getAqsCountries = async (authData: IAuthData): Promise<ICountry[]> => {
	const url = `${process.env.REACT_APP_URL_BACK_UFINET_HUB}api/countries/catalog`
	const fetchOptions: FetchOptions = {
		...defaultOptionsFetch,
		apiKey: process.env.REACT_APP_AUTHORITIES_API_KEY,
		sendApiKey: true,
		notifyError: false,
		authenticationData: authData,
	}

	return await FetchAPI.get<ICountry[]>(url, fetchOptions)
}
